import { useContext } from "react";

import { IntercomContext } from "../contexts/IntercomContext";

export function useIntercomCustom() {
  const context = useContext(IntercomContext);

  return context;
}
